module.exports = __webpack_public_path__ + "static/identity-bee7bbe8a1b9d1b5c55e467de7694600.png";